import StringUtils from '../text/StringUtils';
export default class PathUtils {
    static endsWithDirectorySeparator(path) {
        return StringUtils.endsWithAny(path, PathUtils.VALID_PATH_CHARS);
    }
    static getExtension(path) {
        const extensionSeparatorIndex = path.lastIndexOf(PathUtils.EXTENSION_SEPARATOR_CHAR);
        if (extensionSeparatorIndex !== -1) {
            return path.substring(extensionSeparatorIndex);
        }
        else {
            return undefined;
        }
    }
    static getFileName(path) {
        const lastDirectorySeparatorIndex = PathUtils.getLastDirectorySeparatorIndex(path);
        if (lastDirectorySeparatorIndex !== -1) {
            return path.substring(PathUtils.getLastDirectorySeparatorIndex(path) + 1);
        }
        else {
            return undefined;
        }
    }
    static getFileNameWithoutExtension(path) {
        const extensionSeparatorIndex = path.lastIndexOf(PathUtils.EXTENSION_SEPARATOR_CHAR);
        if (extensionSeparatorIndex !== -1) {
            return path.substring(0, path.lastIndexOf(PathUtils.EXTENSION_SEPARATOR_CHAR));
        }
        else {
            return undefined;
        }
    }
    static getLastDirectorySeparatorIndex(path) {
        return StringUtils.lastIndexOfAny(path, PathUtils.VALID_PATH_CHARS);
    }
    static join(...paths) {
        let result;
        for (const path of paths) {
            if (path === undefined) {
                continue;
            }
            else if (result === undefined) {
                result = path;
            }
            else {
                const resultHasSep = PathUtils.endsWithDirectorySeparator(result);
                const pathHasSep = PathUtils.startsWithDirectorySeparator(path);
                if (!resultHasSep && !pathHasSep) {
                    result += PathUtils.PATH_CHAR + path;
                }
                else if (resultHasSep && pathHasSep) {
                    result += PathUtils.PATH_CHAR + StringUtils.trimLeft(path, PathUtils.VALID_PATH_CHARS.join(''));
                }
                else {
                    result += path;
                }
            }
        }
        return result !== null && result !== void 0 ? result : '';
    }
    static replaceExtension(path, newExtWithDot) {
        const extensionSeparatorIndex = path.lastIndexOf(PathUtils.EXTENSION_SEPARATOR_CHAR);
        if (extensionSeparatorIndex !== -1) {
            return path.substring(0, extensionSeparatorIndex) + newExtWithDot;
        }
        else {
            return path;
        }
    }
    static startsWithDirectorySeparator(path) {
        return StringUtils.startsWithAny(path, PathUtils.VALID_PATH_CHARS);
    }
}
PathUtils.EXTENSION_SEPARATOR_CHAR = '.';
PathUtils.PATH_CHAR = '/';
PathUtils.VALID_PATH_CHARS = ['/', '\\'];
//# sourceMappingURL=PathUtils.js.map